import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Tell the HTML-level boot fallback that React mounted successfully.
// This cancels the 12s safety-net timer AND removes the fallback DOM,
// guaranteeing that even on slow review-farm emulators (Google Play
// reviewers saw the fallback because their device was too slow) the
// recovery screen never appears once the app is alive.
if (typeof window !== "undefined" && typeof window.__hushAppMounted === "function") {
  // Defer one microtask so React's commit phase has actually run.
  Promise.resolve().then(() => {
    try { window.__hushAppMounted(); } catch (_) { /* noop */ }
  });
}
